import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import { toast } from 'react-toastify';
import ResponsiveTable from "../../components/ResponsiveTable";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";

export default function UserList() {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState([]);
  const getRoleData = () => {
    axios.get("/users").then((res) => {
      setFiltered(res.data);
    });
  }

  useEffect(() => {
    getRoleData()
  }, []);

  const capitalizeFirstLetter = (word) => {
    if (!word || typeof word !== "string") return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  const actions = [
    { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
    { divider: true },
    { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
  ];
  const handleActionClick = (action, row) => {
    switch (action) {
      case "edit":
        navigate(`/edit-user/${row.id}`);
        break;
      case "delete":
        if (window.confirm("Are you sure you want to delete this Expenses?")) {
          axios.delete(`/users/${row.id}`).then((res) => {
            if (res.data.success === true) {
              toast.success(res.data.message || "Delete Expenses Successfully")
              getRoleData()
            }

          })
            .catch(err => toast.error(err.message || `Error`));
        }
        break;
      default:
        break;
    }
  };
  const handleDownload = (type) => {
    const url = `${apiBaseUrl}/purchases/export/${type}`;
    window.open(url, "_blank");
  };
  const columns = [
    { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
    {
      header: "Name", accessor: "name"
    },
    { header: "Email Address", accessor: "email" },
    {
      header: "Role Name", accessor: "role_name",
      render: (value, row) => <span className="text-greed-800 font-bold">{value}</span>
    },
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
      <div className="w-full">
        <ExportButtons title="User List" onDownload={handleDownload} />
        <ResponsiveTable
          columns={columns}
          data={filtered}
          showActions
          actionButtons={actions}
          onActionClick={handleActionClick}
        />
      </div>
    </div>
  );
}